export class WordTaskExpect {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get isExpectingNumber() {
        return !this.wordTask.wordings.find(wording => !wording.inputComparer.parseExpect.isRawExpectedStringANumber);
    }
}
